// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a090678a","553":"9f1aec73","977":"c5c9f69a"}[chunkId] + ".chunk.js";
};